import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { getRedemptionList } from "@irati/deals/apollo/query/DealRedemptionList";
import NoExist from "@irati/ui/src/Layout/NoExist";
import Loading from "@irati/ui/src/Loading";
import ShowMoreButton from "./ShowMoreButton";
var ShowMoreOrThatsAll = function (_a) {
    var onNewPage = _a.onNewPage, apollo = _a.apollo;
    var _b = useState(null), load = _b[0], setLoad = _b[1];
    var _c = getRedemptionList(apollo), results = _c.results, _d = _c.limit, limit = _d === void 0 ? 9 : _d, cursor = _c.cursor;
    var thatsAll = !cursor;
    var showMoreButton = !thatsAll && !!(results === null || results === void 0 ? void 0 : results.length) && (results.length % (limit * 3) === 0);
    return (React.createElement(React.Fragment, null,
        !showMoreButton && (React.createElement(VisibilitySensor, { partialVisibility: true, onChange: function (isVisible) { return setLoad(onNewPage(isVisible, apollo)); } },
            React.createElement("div", { style: { height: 10 } }))),
        React.createElement(Loading, { load: load },
            showMoreButton && React.createElement(ShowMoreButton, { onClick: function () { return setLoad(onNewPage(true, apollo)); } }),
            thatsAll && React.createElement(NoExist, null))));
};
export default ShowMoreOrThatsAll;
